module.exports = __webpack_public_path__ + "fonts/quicksand-v20-latin-300.d590f9b6.eot";